import React, {useEffect} from 'react';

import {useApi} from "../../../providers/ApiProvider";
import BusinessesModel from "../../../models/BusinessesModel";
import {Link, useParams} from "react-router-dom";
import {useBreadcrumbs} from "../../../providers/BreadcrumbsProvider";
import BusinessViewHeader from "./../BusinessViewHeader";
import BusinessViewMenu from "../BusinessViewMenu";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../../providers/TranslationProvider";
import BusinessCompetitorCard from "./BusinessCompetitorCard";
import StarRating from "../../ui/StarRating";
import dayjs from "dayjs";

function BusinessCompetitorView({}) {
    const {language} = useMyTranslation();
    const { t} = useTranslation();
    const params = useParams();
    const apiContext = useApi();
    const businessesModel = new BusinessesModel(apiContext.api);


    const breadcrumbs = useBreadcrumbs();
    const [competitor, setCompetitor] = React.useState({});
    const [loading, setLoading] = React.useState(false);


    const setMetaData = (profile, data) => {
        breadcrumbs.update({
            title: profile?.title ?? '',
            breadcrumbs: [
                {label: t('Businesses List'), url: '/businesses'},
                {label: profile?.title ?? '', url: '/businesses/'+params.locationId},
                {label: t('Competitors'), url: '/businesses/'+params.locationId+'/competitors'},
                {label: data?.name ?? ''}
            ]
        });

        document.title = (data?.name ?? '')+' | '+(profile?.title ?? '')+' | LocalBoost';
    }


    const onProfileRefresh = (profile, lastUpdated) => {
        setMetaData(profile);
    }


    useEffect(() => {
        businessesModel.view(params.locationId, params.competitorId).then((response) => {
            if (response !== false) {
                let profile = response.data;

                businessesModel.getCompetitor(params.locationId, params.competitorId).then((response) => {
                    if (response !== false) {
                        setMetaData(profile, response);

                        setCompetitor(response);
                    }
                });
            }
        });
    }, [language]);


    return (
        <>
			<BusinessViewHeader
				locationId={params.locationId}
				onProfileRefresh={onProfileRefresh}
			/>
			<BusinessViewMenu locationId={params.locationId} active="competitors" />

            <div className="d-flex justify-content-start my-4">
                <Link to={`/businesses/${params.locationId}/competitors`} className="btn btn-light-info text-info">
                    <i className="ti ti-arrow-left me-2"></i>
                    {t('Back to all competitors')}
                </Link>
            </div>

            <div className="d-flex flex-column w-75">
                <h3 className="">{competitor?.name ?? 'No title'}</h3>
                <StarRating rating={competitor?.data?.rating ?? 0} />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="fs-2 mb-0 one-liner w-100 d-flex flex-column gap-2">
                        {competitor?.data?.googleMaps ? (<div>
                        Check on Google Maps:
                        <a href={competitor?.data?.googleMaps} target="_blank" className="d-block">{competitor?.data?.googleMaps}</a>
                        </div>) : null}
                        {competitor?.data?.formattedAddress ? (<div>
                        Address:
                        <span className="text-muted d-block">{competitor?.data?.formattedAddress}</span>
                        </div>) : null}

                        {competitor?.data?.websiteUri ? (<div>
                        Website:
                        <a href={competitor?.data?.websiteUri} target="_blank" className="d-block">{competitor?.data?.websiteUri}</a>
                        </div>) : (
                        competitor?.data?.website ? (<div>
                        Website:
                        <a href={competitor?.data?.website} target="_blank" className="d-block">{competitor?.data?.website}</a>
                        </div>) : null
                        )}

                        {competitor?.data?.phone ? (<div>
                        Phone:
                        <span className="text-muted d-block">{competitor?.data?.phone}</span>
                        </div>) : (
                        competitor?.data?.internationalPhoneNumber ? (<div>
                        Phone:
                        <span className="text-muted d-block">{competitor?.data?.internationalPhoneNumber}</span>
                        </div>) : null
                        )}
                    </div>
                </div>
            </div>

            <div className="mt-3 text-end fs-2">
                <i className="ti ti-refresh fs-3 me-2"></i> {dayjs(competitor?.synced_at).isValid() ? t('Last synced on {{date}}', {date: dayjs(competitor?.synced_at).format('MMM D, YYYY, HH:mm')}) : t('Not synced yet')}
            </div>
        </>
    );
}

export default BusinessCompetitorView;
